import { FileTypeOption } from "./FileTypeSelector";

export const FILE_TYPE_OPTIONS: FileTypeOption[] = [
	{ value: "pdf", label: "PDF" },

	{ value: "xls", label: "XLS" },
	{ value: "xlsx", label: "XLSX" },
	{ value: "csv", label: "CSV" },

	{ value: "doc", label: "DOC" },
	{ value: "docx", label: "DOCX" },
	{ value: "txt", label: "TXT" },

	{ value: "jpg", label: "JPG" },
	{ value: "jpeg", label: "JPEG" },
	{ value: "png", label: "PNG" },

	{ value: "ppt", label: "PPT" },
	{ value: "pptx", label: "PPTX" },

	{ value: "zip", label: "ZIP" },
	{ value: "7z", label: "7Z" },
	{ value: "rar", label: "RAR" },

	{ value: "mp4", label: "MP4" },

	{ value: "mp3", label: "MP3" },
];
